import React, { useEffect, useState } from 'react';
import { List, Spin } from 'antd';
import axios from 'axios';

const estatus = [
    { _id: 0, name: 'pendiente', label: "Pending" },
    { _id: 6, name: 'pendiente', label: "Pending Payment / Delivered" },
    { _id: 1, name: 'recibido', label: "Order Received" },
    { _id: 2, name: 'lavado', label: "Cleaning in Progress" },
    { _id: 3, name: 'detallado', label: "Final Detailing Touches" },
    { _id: 8, name: 'listo', label: "Almost Ready" },
    { _id: 4, name: 'empaquetado', label: "Order Ready" },
    { _id: 7, name: 'empaquetado', label: "Order Ready For Delivery" },
    { _id: 5, name: 'entregado', label: "Order Completed" },
];

function reemplazarEstatus(texto) {
    let nuevoTexto = texto;
    estatus.forEach(e => {
        const regex = new RegExp(`\\b${e._id}\\b`, 'g');
        nuevoTexto = nuevoTexto.replace(regex, e.label);
    });
    return nuevoTexto;
}

function normalizeCambio(cambio) {
    if (typeof cambio === 'string') return reemplazarEstatus(cambio);
    if (Array.isArray(cambio)) return normalizeCambio(cambio[0]);
    if (cambio && typeof cambio === 'object') {
        if (typeof cambio.message === 'string' && cambio.message.trim() !== '') return cambio.message;
        const numericKeys = Object.keys(cambio).filter(k => /^\d+$/.test(k)).sort((a, b) => Number(a) - Number(b));
        if (numericKeys.length > 0) {
            const str = numericKeys.map(k => String(cambio[k])).join('');
            return reemplazarEstatus(str);
        }
        const possibleChars = Object.keys(cambio)
            .map(k => cambio[k])
            .filter(v => typeof v === 'string' && v.length === 1);
        if (possibleChars.length > 0) return reemplazarEstatus(possibleChars.join(''));
        try {
            return JSON.stringify(cambio);
        } catch (e) {
            return String(cambio);
        }
    }
    return String(cambio ?? '');
}

export default function TableHistorial({ venta_id }) {
    const [loading, setLoading] = useState(true);
    const [historial, setHistorial] = useState([]);
    const [usuariosMap, setUsuariosMap] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get(`/venta/bitacora/${venta_id}`);
                setHistorial(res.data);

                const uniqueUserIds = [...new Set(res.data.map(item => item.usuario_id).filter(Boolean))];
                const usersPromises = uniqueUserIds.map(id => axios.get(`/usuarios/${id}`));
                const usersResults = await Promise.all(usersPromises);

                const map = {};
                usersResults.forEach(r => {
                    if (r.data && r.data._id) {
                        map[r.data._id] = r.data;
                    }
                });
                setUsuariosMap(map);
            } catch (err) {
                console.error("Error fetching history or users:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [venta_id]);

    if (loading) return <Spin />;

    return (
        <List
            itemLayout="horizontal"
            dataSource={historial}
            renderItem={item => {
                const usuario = usuariosMap[item.usuario_id];
                const nombreCompleto = usuario ? `${usuario.nombre} ${usuario.apellidos}` : "Unknown user";

                const cambiosArray = Array.isArray(item.cambios) ? item.cambios : [];
                const cambiosConEstatus = cambiosArray.map(c => normalizeCambio(c));

                return (
                    <List.Item>
                        <List.Item.Meta
                            title={`${new Date(item.fecha).toLocaleString('en-US')} — ${nombreCompleto}`}
                            description={cambiosConEstatus.join(', ')}
                        />
                    </List.Item>
                );
            }}
        />
    );
}